import { client } from '../apiClient';

export interface WatchedPageResponse {
  id: number;
  projectId: number;
  url: string;
  domain: string | null;
  category: string | null;
  isMentioned: boolean;
  mentionCount: number;
  share: number;
  isVerified: boolean;
  brands: string[];
  firstSeen: string | null;
  created: string;
}

const ENDPOINT = '/watched-pages';

export const getWatchedPages = async (projectId: number, chatType?: string): Promise<WatchedPageResponse[]> => {
  return client(true, true)
    .get<WatchedPageResponse[]>(ENDPOINT, { params: { projectId, chatType } })
    .then((response) => response.data)
    .catch((error) => error);
};

export const addWatchedPages = async (
  projectId: number,
  urls: string[]
): Promise<WatchedPageResponse[]> => {
  return client(true, true)
    .post<WatchedPageResponse[]>(ENDPOINT, { projectId, urls })
    .then((response) => response.data)
    .catch((error) => error);
};

export const deleteWatchedPages = async (projectId: number, ids: number[]): Promise<void> => {
  return client(true, true)
    .delete(ENDPOINT, { data: { projectId, ids } })
    .then((response) => response.data)
    .catch((error) => error);
};
